<template>
  <layout-main-inner title="培训课程">
    <div slot="action">
      <el-button
        type="primary"
        @click="additem">
        新增培训课程
      </el-button>
    </div>
    <layout-card-wrap hasSlot>
      <template slot="form">
        <el-input
          v-model="config.courseName"
          clearable
          placeholder="请输入培训课程名称"
          @clear="handleCurrentChange(1)">
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="handleCurrentChange(1)"
          ></el-button>
        </el-input>
      </template>
      <el-table
        border
        :data="list">
        <el-table-column
          label="课程名称"
          min-width="140"
          prop="courseName">
        </el-table-column>
        <el-table-column
          label="课程简介"
          min-width="400"
          prop="courseIntroduction">
        </el-table-column>
        <el-table-column
          width="80"
          label="课程状态">
          <template slot-scope="{ row }">
            <span v-if="row.status === 1">招生中</span>
            <span v-if="row.status === 2">已报满</span>
            <span v-if="row.status === 3">已结业</span>
          </template>
        </el-table-column>
        <el-table-column
          label="培训时间"
          width="160"
          prop="trainingTime">
        </el-table-column>
        <el-table-column
          label="报名电话"
          width="120"
          prop="signUp">
        </el-table-column>
        <el-table-column
          width="150"
          label="封面">
          <template slot-scope="{ row }">
            <el-image
              style="width:120px"
              :src="row.topImage"></el-image>
          </template>
        </el-table-column>
        <el-table-column
          width="80"
          label="培训内容">
          <template slot-scope="{ row }">
            <el-popover
              placement="left-start"
              title="培训内容"
              width="320"
              trigger="hover">
              <el-carousel :autoplay="false">
                <el-carousel-item
                  v-for="(item,index) in row.detailImages"
                  :key="index">
                  <img
                    style="width:100%;height:100%;object-fit: contain;background-color: #000;"
                    :src="item.url"
                    alt="">
                </el-carousel-item>
              </el-carousel>
              <el-button
                slot="reference"
                type="text">查看</el-button>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column
          label="精彩瞬间"
          width="80">
          <template slot-scope="{ row }">
            <el-popover
              v-if="row.wonderfulMomentImages.length > 0"
              placement="left-start"
              title="精彩瞬间"
              width="320"
              trigger="hover">
              <el-carousel :autoplay="false">
                <el-carousel-item
                  v-for="(item,index) in row.detailImages"
                  :key="index">
                  <img
                    style="width:100%;height:100%;object-fit: contain;background-color: #000;"
                    :src="item.url"
                    alt="">
                </el-carousel-item>
              </el-carousel>
              <el-button
                slot="reference"
                type="text">查看</el-button>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column
          label="创建时间"
          width="150">
          <template slot-scope="{ row }">
            <span>{{ row.createdTime | dateformat() }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          fixed="right"
          width="165">
          <template slot-scope="{ row }">
            <el-button
              type="info"
              @click="updateitem(row)">编辑</el-button>

            <el-dropdown>
              <el-button
                type="primary"
                style="margin-left: 10px;">
                更多<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="deleteitem(row)">删除</el-dropdown-item>
                <el-dropdown-item
                  :disabled="!(row.status === 1)"
                  @click.native="trainingcourseendreg(row)">报名结束</el-dropdown-item>
                <el-dropdown-item
                  :disabled="!(row.status === 1 || row.status === 2)"
                  @click.native="trainingcoursecomplete(row)">课程结业</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        slot="footer"
        background
        :current-page.sync="config.pageNum"
        :page-size="config.pageSize"
        layout="total, prev, pager, next"
        :total="total"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </layout-card-wrap>
    <edit-course-modal
      ref="course"
      :callback="() => { getlist() }"
    />
  </layout-main-inner>
</template>
<script>
import { mapState } from 'vuex'
import EditCourseModal from './edit-course-modal.vue'
export default {
  name: 'LuxuryTrainingCourseIndex',
  components: { EditCourseModal },
  data() {
    return {
      loading: true,
      list: [],
      total: 0,
      config: {
        pageNum: 1,
        pageSize: 10,
        courseName: ''
      }
    }
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.account.userInfo
    })
  },
  mounted() {
    this.getlist()
  },
  methods: {
    updateitem(row) {
      this.$refs.course.update({
        trainingCourseId: row.trainingCourseId,
        courseName: row.courseName,
        courseIntroduction: row.courseIntroduction,
        trainingTime: row.trainingTime,
        signUp: row.signUp,
        status: row.status,
        topImage: row.topImage ? row.topImage.split(',').map(url => ({ url })) : [],
        wonderfulMomentImages: row.wonderfulMomentImages,
        detailImages: row.detailImages
      })
    },
    additem() {
      this.$refs.course.add(this.userInfo.orgId)
    },
    trainingcourseendreg(row) {
      this.$confirm('您确定将课程设置为报名结束?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true
        this.$store.dispatch('account/trainingcourseendreg', {
          payload: {
            trainingCourseId: row.trainingCourseId
          },
          success: () => {
            this.loading = false
            this.getlist()
          },
          fail: () => {
            this.loading = false
          }
        })
      })
    },
    trainingcoursecomplete(row) {
      this.$confirm('您确定将课程设置为已结业?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true
        this.$store.dispatch('account/trainingcoursecomplete', {
          payload: {
            trainingCourseId: row.trainingCourseId
          },
          success: () => {
            this.loading = false
            this.getlist()
          },
          fail: () => {
            this.loading = false
          }
        })
      })
    },
    deleteitem(row) {
      console.log(row)
      this.$confirm('您确定删除该培训课程?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true
        this.$store.dispatch('account/deletetrainingcourse', {
          payload: {
            trainingCourseId: row.trainingCourseId
          },
          success: () => {
            this.loading = false
            this.getlist()
          },
          fail: () => {
            this.loading = false
          }
        })
      })
    },
    handleCurrentChange(val) {
      this.config.pageNum = val
      this.getlist()
    },
    getlist() {
      this.loading = true
      this.$store.dispatch('account/gettrainingcourses', {
        payload: this.config,
        success: (res) => {
          this.loading = false
          this.total = res.data.total
          this.list = res.data.records.map(i => {
            return {
              ...i,
              wonderfulMomentImages: i.wonderfulMomentImages ? i.wonderfulMomentImages.split(',').map(url => ({ url })) : [],
              detailImages: i.detailImages.split(',').map(url => ({ url }))
            }
          })
        },
        fail: () => {
          this.loading = false
        }
      })
    }
  }
}
</script>
